;(function() {
  'use strict'

  SurveyShare.$inject = ["$scope", "shareService"];
  angular.module('app.survey').controller('SurveyShare', SurveyShare)

  /* @ngInject */
  function SurveyShare($scope, shareService) {
    var options = {
      text: $scope.text,
      image: $scope.image,
      url: $scope.url,
    }

    $scope.share = share

    function share(platform) {
      shareService.manualShare(platform, options)
    }
  }
})()
